import { Tab, Tabs } from "@focus/focusUI";
import * as React from "react";
import { GraphsGroup } from "./GraphGroup";
import { getFileNameWithoutExtension } from "./utils";
export class GraphsTabs extends React.PureComponent {
    render() {
        const { data, tabs, ignoreFileName, folderType, baseFileName } = this.props;
        let cleanedBaseFileName = getFileNameWithoutExtension(baseFileName);
        if (tabs.length === 1) {
            return (React.createElement(React.Fragment, null,
                React.createElement(GraphsGroup, { data: data, hideTitle: this.props.hideTitle, key: tabs[0].id, tab: tabs[0], folderType: folderType, baseFileName: cleanedBaseFileName })));
        }
        else {
            return (React.createElement(Tabs, { id: "GrafosTabs", className: "tabHolder grafosTabs", renderActiveTabPanelOnly: true },
                tabs.map((tab) => (React.createElement(Tab, { key: tab.id, title: tab.title, id: tab.id, panel: React.createElement("div", { style: {
                            bottom: "0px",
                            left: "20px",
                            overflow: "hidden",
                            position: "absolute",
                            right: "0px",
                            top: "40px",
                        } },
                        React.createElement(GraphsGroup, { key: tab.id, tab: tab, ignoreFileName: ignoreFileName, data: data, folderType: folderType, baseFileName: cleanedBaseFileName })) }))),
                React.createElement(Tabs.Expander, null),
                this.props.children));
        }
    }
}
//# sourceMappingURL=GraphsTabs.js.map